import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ConfirmDeleteProps {
  title?: string;
  description?: string;
  onConfirm: () => void;
  children?: React.ReactNode;
  disabled?: boolean;
}

export function ConfirmDelete({
  title = 'Are you sure?',
  description = 'This action cannot be undone.',
  onConfirm,
  children,
  disabled = false,
}: ConfirmDeleteProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild disabled={disabled}>
        {children ?? (
          <button
            disabled={disabled}
            className='h-8 w-8 rounded-lg border border-sd-input bg-sd-background flex items-center justify-center hover:bg-sd-muted transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
          >
            <Trash2 className='h-3.5 w-3.5 text-sd-muted-foreground' />
          </button>
        )}
      </AlertDialogTrigger>
      <AlertDialogContent className='sd-scope sd-font'>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('cancel')}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={disabled}
            className='bg-sd-destructive text-sd-destructive-foreground hover:bg-sd-destructive/90 disabled:opacity-50 disabled:cursor-not-allowed'
          >
            {t('delete')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
